import { DRAWINGS_TAB, MATERIAL_TRACKING_TAB } from './Components/projectTabRouting';

export const PROJECT_FEATURE_TITLES: Record<number, string> = {
	1: 'Scope of Work Documents',
	2: 'Coordination Mark-ups',
	3: 'Contract Inclusions',
	4: 'Contract Documents',
	5: 'Users',
	6: 'Change Log',
	7: 'Scope Checklists',
	8: 'Scope Gap Analysis',
	9: 'Quote Review',
	10: 'Project Information',
	[MATERIAL_TRACKING_TAB]: 'Material Tracking',
	[DRAWINGS_TAB]: 'Drawings',
};

const NAMED_PROJECT_FEATURE_TABS: Record<string, number> = {
	'quote-review': 9,
	'scope-checklists': 7,
	'scope-gap-analysis': 8,
	'material-tracking': MATERIAL_TRACKING_TAB,
	drawings: DRAWINGS_TAB,
};

export const getProjectTabFromSearch = (search: string): number | null => {
	const queryValue = new URLSearchParams(search).get('tab') || '';
	if (NAMED_PROJECT_FEATURE_TABS[queryValue]) {
		return NAMED_PROJECT_FEATURE_TABS[queryValue];
	}
	if (!/^\d+$/.test(queryValue) || /^0\d+/.test(queryValue)) {
		return null;
	}
	const queryTab = Number(queryValue);
	return PROJECT_FEATURE_TITLES[queryTab] ? queryTab : null;
};

export const hasProjectFeatureSelection = (search: string): boolean =>
	getProjectTabFromSearch(search) !== null;
